<div adminGrid
     [gridConfig]="gridConfig"
     (gridCallback)="onGridCallback($event)"
     class="gizmo-grid"
     tabindex="2"></div>
